/**
 * A marca escolhida no topo da interface.
 *
 * Tudo que é conteúdo — mídia, logos, modelos de arte, calendário, as contas
 * oferecidas na Nova peça — passa a ser DA MARCA escolhida aqui. A seleção é
 * por marca, não por conta: quando o LinkedIn entrar, ele é mais uma conta da
 * mesma marca e enxerga a mesma biblioteca.
 *
 * As telas leem `marcaAtual()` ao montar e passam o slug EXPLICITAMENTE para a
 * API. Um filtro implícito dentro de `api.ts` seria menos código e esconderia
 * de quem lê a tela de qual biblioteca aquilo vem.
 *
 * A escolha fica no `localStorage` de quem usa — conveniência, não dado do
 * sistema. Toda leitura e escrita em try/catch: em aba anônima o acesso lança,
 * e a interface tem de abrir mesmo assim.
 */
import type { Marca } from "./api.js";

const CHAVE = "nex-social:marca";

let marcas: Marca[] = [];
let atual: Marca | null = null;

/** Chamado uma vez, na abertura, com o que `GET /brands` devolveu. */
export function definirMarcas(lista: Marca[]): void {
  marcas = lista;
  let guardada: string | null = null;
  try {
    guardada = localStorage.getItem(CHAVE);
  } catch {
    // Sem armazenamento, começa pela primeira marca.
  }
  atual = lista.find((m) => m.slug === guardada) ?? lista[0] ?? null;
}

export function todasAsMarcas(): readonly Marca[] {
  return marcas;
}

/**
 * A marca escolhida. Lança se não houver nenhuma: tela de conteúdo sem marca
 * mostraria a biblioteca de ninguém, e um erro explícito é melhor que uma
 * lista vazia que parece "nada enviado ainda".
 */
export function marcaAtual(): Marca {
  if (!atual) {
    throw new Error(
      "Nenhuma marca cadastrada com conta. Cadastre uma conta antes de criar conteúdo."
    );
  }
  return atual;
}

export function escolherMarca(slug: string): void {
  const m = marcas.find((x) => x.slug === slug);
  if (!m) return;
  atual = m;
  try {
    localStorage.setItem(CHAVE, slug);
  } catch {
    // A troca vale para esta sessão mesmo sem persistir.
  }
}
